var React = require('react');

function View (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M796-121 533-384q-30 26-70 40.5T378-329q-108 0-183-75t-75-181q0-106 75-181t182-75q106 0 180.5 75T632-585q0 43-14 83t-42 75l264 262-44 44ZM377-389q81 0 138-57.5T572-585q0-81-57-138.5T377-781q-82 0-139.5 57.5T180-585q0 81 57.5 138.5T377-389Z"}));
}

View.defaultProps = {"height":"48px","viewBox":"0 -960 960 960","width":"48px","fill":"#FFFFFF"};

module.exports = View;

View.default = View;
